import React from 'react';
import { NexusFooter, NexusFooterBottom } from '@nexus/react';

const Footer = React.memo(() => {
    return (
        <div className='nexus-flex-shrink-0' id='page-footer'>
            <NexusFooter>
                <NexusFooterBottom>
                    <p className='nexus-body'>Copyright&#169; 2025 Ernst & Young LLP. All rights reserved.</p>
                </NexusFooterBottom>
            </NexusFooter>
        </div>
    );
});
export default Footer;
